import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { Divider, Form, Menu, Responsive } from "semantic-ui-react";

import ParishProfileTab from "../../data/enums/ParishProfileTab";

interface IParishProfileControllerProps {
    currentTab: string;
    editMode: boolean;
    setCurrentTab(newCurrentTab: string): void;
}

const ParishProfileController: React.FC<IParishProfileControllerProps> = (props: IParishProfileControllerProps) => {
    const { currentTab, setCurrentTab, editMode } = props;

    const handleCurrentTabChange = (e: any, { value }: any) => setCurrentTab(value);

    return (
        <>
            {editMode && <Responsive as={Divider} maxWidth={768} style={{ marginTop: "6em" }} />}
            <Form>
                <Menu color="violet" fluid secondary size="huge" vertical>
                    <Menu.Item
                        active={currentTab === ParishProfileTab.general}
                        id="general"
                        onClick={handleCurrentTabChange}
                        value={ParishProfileTab.general}
                    >
                        <FM id="profile.generalData" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === ParishProfileTab.pictures}
                        disabled
                        id="pictures"
                        value={ParishProfileTab.pictures}
                        // onClick={handleCurrentTabChange}
                    >
                        <FM id="menu.pictures" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === ParishProfileTab.files}
                        disabled
                        id="files"
                        value={ParishProfileTab.files}
                        // onClick={handleCurrentTabChange}
                    >
                        <FM id="menu.files" />
                    </Menu.Item>
                </Menu>
            </Form>
        </>
    );
};

export default ParishProfileController;
